import React from 'react'
import type { SvgIconSize } from 'LuxKit/SvgIcon'
import type { TripItineraryItem } from 'tripPlanner/api/types'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineGlassMartiniIcon from 'LuxKit/Icons/line/LineGlassMartiniIcon'
import LineWalkingIcon from 'LuxKit/Icons/line/LineWalkingIcon'
import LineCameraIcon from 'LuxKit/Icons/line/LineCameraIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineShoppingBagIcon from 'LuxKit/Icons/line/LineShoppingBagIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'

const icons = {
  coffee: LineCoffeeIcon,
  dining: LineRestaurantIcon,
  drinks: LineGlassMartiniIcon,
  walk: LineWalkingIcon,
  sightseeing: LineCameraIcon,
  event: LineTicketIcon,
  shopping: LineShoppingBagIcon,
  social: LineHeartIcon,
  transport: LineCarIcon,
  general: LineStarIcon,
}

export default function ActivityIcon({ iconKey, size }: Pick<TripItineraryItem, 'iconKey'> & { size?: SvgIconSize }) {
  const Icon = iconKey && icons[iconKey] || icons.general
  return <Icon size={size} />
}
